import styled from 'styled-components';
import { ProgressStepperMixin } from '../../mixins/components/ProgressStepperMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledProgressStepper = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['orientation'])
}).withConfig({
  displayName: "StyledProgressStepper",
  componentId: "c11n-8-111-1__sc-qxlz2f-0"
})(["", ""], ProgressStepperMixin);